/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { setEmbedPlacement } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import PlacementPage from 'pages/dashboard/embeds/management/placement/placement';



/* ========== ~~~~~~~~~~ EMBED PLACEMENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    stepQueue: embedsState.embedManagementState.embedManagementStatus.stepQueue,
    currentStepIndex: embedsState.embedManagementState.embedManagementStatus.currentStepIndex,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    embedChangeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected,
    contentChangeDetected: embedsState.embedManagementState.contentStatus.contentChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
        dispatch(updatePageDetails(`dashboard/embeds/management/${location}`));
        dispatch(updateStepDetails(location));
    	dispatch(changePage(`dashboard/embeds/management/${location}`))
    },
	setEmbedPlacement: (placement) => {
		dispatch(setEmbedPlacement(placement))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlacementPage);
